module.exports = __webpack_public_path__ + "img/aquavie.6b764203.png";